<template>
	<page-container :page="page" :locale="locale">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section v-if="defaults[locale].contact.routeDescription.length" class="main-content align-center">
			<route-descriptions
				:items="defaults[locale].contact.routeDescription"
				:header="defaults[locale].contact.contactFormHeader"
			/>
		</section>

		<section class="main-content background-light">
			<div class="row contact-form-row">
				<div class="columns column6 maps">
					<iframe
						id="maps"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2452.950082382287!2d5.306533876925899!3d52.062432570005285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c65cc8dfce2ad1%3A0x84b7a90a66ca5119!2sBuitenplaats%20de%20Bergse%20Bossen!5e0!3m2!1sen!2snl!4v1729079532640!5m2!1sen!2snl"
						width="100%"
						height="450"
						style="border: 0"
						allowfullscreen=""
						loading="lazy"
					/>
				</div>
				<div class="columns column6 contact-form-col">
					<div class="contentblock-content">
						<h2>{{ $t('contactFormHeader') }}</h2>
						<contact-form v-if="form" name="contact" :form="form" />
					</div>
				</div>
			</div>
		</section>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();
useRemoveGifty();

const { data: form } = await useWebsiteFetch('contact', {
	query: { language: locale.value },
	key: `${locale.value}/contact`,
});
</script>

<style lang="scss" scoped>
#maps {
	min-height: 600px;
	height: 100%;
	width: 100%;
}

.contact-form-row {
	display: flex;
	align-items: center;
	flex-flow: row wrap;
	justify-content: flex-end;
	padding: 0;
	margin: 40px auto;
	position: relative;

	.columns:first-child {
		padding: 0;
	}

	.contact-form-col {
		padding: 50px 0;
		position: relative;
		z-index: 2;
	}

	.maps {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 51%;
	}

	.contentblock-content {
		padding: 75px;
		background: #fff;
	}
}

@media (max-width: 1080px) {
	#maps {
		min-height: 400px;
	}

	.contact-form-row {
		.maps {
			width: 100%;
			position: relative;
		}

		.contact-form-col {
			padding: 0;
			width: 92%;
			margin: -25px auto 0;
		}

		.contentblock-content {
			padding: 50px;
		}
	}
}

@media (max-width: 580px) {
	.contact-form-row {
		margin-bottom: 25px;

		.contentblock-content {
			padding: 35px;
		}
	}
}
</style>
